var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrendDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2128_199901)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.863604 18.8865C0.512132 18.535 0.512132 17.9652 0.863604 17.6137L10.3636 8.1137C10.5324 7.94492 10.7613 7.8501 11 7.8501C11.2387 7.8501 11.4676 7.94492 11.6364 8.1137L16 12.4773L22.8636 5.6137C23.2151 5.26223 23.7849 5.26223 24.1364 5.6137C24.4879 5.96517 24.4879 6.53502 24.1364 6.88649L16.6364 14.3865C16.4676 14.5553 16.2387 14.6501 16 14.6501C15.7613 14.6501 15.5324 14.5553 15.3636 14.3865L11 10.0229L2.1364 18.8865C1.78493 19.238 1.21508 19.238 0.863604 18.8865Z",
    fill: "#CD4C41"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.4 18.2501C8.4 18.7472 7.99706 19.1501 7.5 19.1501H1.5C1.00295 19.1501 0.600001 18.7472 0.600001 18.2501V12.2501C0.600001 11.753 1.00295 11.3501 1.5 11.3501C1.99706 11.3501 2.4 11.753 2.4 12.2501V17.3501H7.5C7.99706 17.3501 8.4 17.753 8.4 18.2501Z",
    fill: "#CD4C41"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2128_199901"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "matrix(1 0 0 -1 0.5 24.25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrendDown);
export default __webpack_public_path__ + "static/media/trendDown.05368b509b3eb0c8a7aa416793b637d2.svg";
export { ForwardRef as ReactComponent };